<template>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="pageContainer">
      <div class="row">
        <div class="col-lg-9">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard">
                  <div class="row">
                    <div class="col-sm-12">
                     <h4 class="reference">Air Conditioning Report</h4>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>
                  <form @submit.prevent="updateOrder">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="itemsGroup">
                          
                          
                          <div class="itemsList">
                            <dt class="item">Site Address</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.site_address_id">
                                  <option v-for="address in addresses" :key="address.id" :value="address.id" :selected="address.id === order.site_address_id">({{ address.label }}) {{ address.address1 }}, {{ address.address2 }}, {{ address.city }}, {{ address.county }}, {{ address.postcode }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          
                          <div class="itemsList">
                            <dt class="item">Engineer</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.engineer">
                                  <option value="Will Rae">Will Rae</option>
                                  <option value="Ben White">Ben White</option>
                                  
                                </select>
                              </div>
                            </dd>
                          </div>
                        </div>
                      </div>
                        <div class="col-sm-6">
        
                          <div class="itemsGroup">
                            <div class="itemsList">
                            <dt class="item">Contact</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.contact_id">
                                  <option v-for="contact in contacts" :key="contact.id" :value="contact.id" :selected="contact.id === order.contact_id">{{ contact.first_name }} {{ contact.last_name }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                            <div class="itemsList">
                              <dt class="item">Reference</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.customer_reference" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Customer PO</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.customer_po" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Xero Invoice Number</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.xero_invoice_number" /></dd>
                            </div>
                            
                          </div>
                        </div>
                      <div class="col-sm-4">
                        
                      </div>
                    </div>
                    




                    <div class="row">
                      <div class="col-sm-2">
                        <label style="text-align:left;">Job Description</label>
                      </div>
                      <div class="col-sm-10">
                        <textarea v-model="order.job_description" rows="5" placeholder="Job Description"></textarea>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <hr />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">

                        <table width="100%" border="0" cellpadding="0" cellspacing="0">
                          <thead>
                              <tr>
                                  <td>Location</td>
                                  <td>Make</td>
                                  <td>Indoor Model</td>
                                  <td>Indoor Serial</td>
                                  <td>Outdoor Model</td>
                                  <td>Outdoor Serial</td>
                                  <td>Refrigerant Charge</td>
                                  <td>Cooling Air On</td>
                                  <td>Cooling Air Off</td>
                                  <td>Heating Air On</td>
                                  <td>Heating Air Off</td>
                                  <td></td>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="aircon, index in aircons" :key="aircon.id">
                                  <td><input type="text" v-model="aircon.location" /></td>
                                  <td><input type="text" v-model="aircon.make" /></td>
                                  <td><input type="text" v-model="aircon.indoor_model" /></td>
                                  <td><input type="text" v-model="aircon.indoor_serial" /></td>
                                  <td><input type="text" v-model="aircon.outdoor_model" /></td>
                                  <td><input type="text" v-model="aircon.outdoor_serial" /></td>
                                  <td><input type="text" v-model="aircon.refrigerant_charge" /></td>
                                  <td><input type="text" v-model="aircon.cooling_air_on" /></td>
                                  <td><input type="text" v-model="aircon.cooling_air_off" /></td>
                                  <td><input type="text" v-model="aircon.heating_air_on" /></td>
                                  <td><input type="text" v-model="aircon.heating_air_off" /></td>
                                  <td><div align="center"><img src="~@/assets/images/icon/remove.svg" width="10" @click.prevent="deleteItem(index)" /></div></td>
                              </tr>
                              
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="11">
                                <div class="addNewItemLink" @click.prevent="addNewItem()">
                                  <font-awesome-icon icon="plus" /> Add another unit
                                </div>
                              </td>
                            </tr>
                          </tfoot>
                      </table>
                      
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <hr />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-2">
                        <label style="text-align:left;">Engineers Report</label>
                      </div>
                      <div class="col-sm-10">
                        <textarea v-model="order.engineers_report" rows="5" placeholder="Engineers Report"></textarea>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <hr />
                      </div>
                    </div>
                    
                    
                    <div class="row">
                      <div class="col-sm-12">
                        <hr />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-1">
                        
                      </div>
                      <div class="col-sm-3">
                        
                      </div>
                      <div class="col-sm-8">
                        <div align="right">
                          <input type="submit" value="Save Job">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                         <a @click.prevent="deleteJob()" class="btnRedText">Delete Job</a>
                      </div>
                      
                      <div class="col-sm-8">
                        
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Reports</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <a href="#" @click.prevent="$openPdf('airconditioning', order.id)" class="btnOrderAction">Air Conditioning Report <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                  
                </div>
                
                

                <div class="pageCard greenTop" v-if="order.status==='processing'">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Complete Job</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <a @click.prevent="completeOrder()" class="btnOrderAction" target="_blank" >Complete Job <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                </div>

                <div class="pageCard greenTop" v-if="!order.invoice_status">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Invoice Job</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <a @click.prevent="invoiceOrder()" class="btnOrderAction" target="_blank" >Invoice Job <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import axios from 'axios'

export default {
  components: { /*DatePicker*/ },
  data () {
    return {
      order: [],
      contacts: [],
      addresses: [],
      airconditioning: [],
      assets: [],
      aircons: [],
    }
  },
  watch: {
    productInput (after, before) {
      if (after === null || before === null) {
        this.DoNothing()
      } else {
        this.searchProduct()
      }
    }
  },
  created () {
    axios
      .get(`/api/orders/${this.$route.params.id}`)
      .then((res) => {
        this.order = res.data.order
        axios
          .get(`/api/companies/${this.order.company_id}/contacts`)
          .then(response => {
            this.contacts = response.data
          })
        axios
          .get(`/api/companies/${this.order.company_id}/addresses`)
          .then(response => {
            this.addresses = response.data
          })
        axios
          .get(`/api/orders/${this.$route.params.id}/aircon`)
          .then(response => (
            this.aircons = response.data
          ))
          
      })
    
  },
  methods: {
    onFocus: function () {
      this.isVisible = true
      this.searchProduct()
    },
    onBlur: function () {
      // this.isVisible = false
    },
    addNewItem () {
      this.aircons.push({})
    },
    deleteItem (id) {
      this.$delete(this.aircons, id)
    },
    
    
    deleteJob () {
      axios
        .delete(`/api/orders/${this.$route.params.id}`)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job deleted", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    updateOrder () {

      let dates= new Date()
          let month = dates.getUTCMonth() + 1
          let day = dates.getUTCDate()
          let year = dates.getUTCFullYear()
          let currentDate = year + "-" + month + "-" + day
      /*
      if (!this.order.signature_image) {
        const { isEmptyEngineer, dataEngineer } = this.$refs.signaturePad.saveSignature();

        if (!isEmptyEngineer) {
          this.order.date_signed = currentDate;
          this.order.currentDate = dataEngineer;
        }

      }
      */

      axios
        .put(`/api/orders/${this.$route.params.id}`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          axios
            .put(`/api/orders/${this.$route.params.id}/aircon`, this.aircons)
            .then(response => (
              this.$toast.success("Job saved", {}),
              this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
            ))
            .catch(err => console.log(err))
            // .finally(() => this.loading = false)
         
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    completeOrder () {
      axios
        .put(`/api/orders/${this.$route.params.id}/actions/complete`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job completed", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    invoiceOrder () {
      axios
        .put(`/api/orders/${this.$route.params.id}/actions/invoice`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job invoiced", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
      }
  }
}
</script>
